import { createSlice } from '@reduxjs/toolkit'
// import axios from '../axios';

const coreSlice = createSlice({
	name: 'core',
	initialState: {
		sidebar: true,
		bootstrapped: false,
		overQuota: null // Set to the quota per day number if so
	},
	reducers: {
		setSidebar(state, action) {
			state.sidebar = action.payload;
		},
		setBootstrapped(state, action) {
			state.bootstrapped = action.payload;
		},
		setOverQuota(state, action) {
			state.overQuota = action.payload;
		}
	}
});

export const { setSidebar, setBootstrapped, setOverQuota } = coreSlice.actions;

export default coreSlice.reducer;